import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import AdminGateLayout from './admin/AdminGateLayout';
import AdminBotPicker from './admin/AdminBotPicker';
import AdminDesignerPage from './admin/AdminDesignerPage';
import PortalPage from './portal/PortalPage';
import BotPage from './BotPage';
import { getDefaultRedirectPath, loadBotsListFromBucket } from '../config/getBotConfig';
import { AuthCallback } from '../services/auth/authService';
import pathRoutes from '../enums/pathRoutes';

function RootRedirect() {
  const to = getDefaultRedirectPath();
  return <Navigate to={to} replace />;
}

export default function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    loadBotsListFromBucket().finally(() => setReady(true));
  }, []);

  if (!ready) return null;

  return (
    <>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/authenticated" element={<AuthCallback />} />
        <Route path={`/${pathRoutes.ADMIN}`} element={<AdminGateLayout />}>
          <Route index element={<AdminBotPicker />} />
          <Route path="*" element={<AdminDesignerPage />} />
        </Route>
        <Route path={`/${pathRoutes.PORTAL}/*`} element={<PortalPage />} />
        <Route path="/*" element={<BotPage />} />
      </Routes>
    </>
  );
}
